import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const CookingWares = createSvgIcon(
  <path d="M.203 0h10.844L9.226 12.75H6.75V24H4.5V12.75H2.024L.203 0Zm7.071 10.5 1.179-8.25H2.797l1.179 8.25h3.298ZM21.86 3.731l2.119-2.118L22.387.022l-2.12 2.118a2.625 2.625 0 0 0-.768 1.856V16.5H9v4.875A2.625 2.625 0 0 0 11.625 24h7.5a2.625 2.625 0 0 0 2.625-2.625V3.996c0-.1.04-.195.11-.265ZM19.5 18.75v2.625a.375.375 0 0 1-.375.375h-7.5a.375.375 0 0 1-.375-.375V18.75h8.25Z" />,
  'CookingWares'
);

export { CookingWares };